import AlertDefinitionInfoPanel from 'thm/ui/common/alertDefinition/AlertDefinitionInfoPanel'
import AlertDefinitionPortTimeInfoPanelTplStache from 'thm/ui/common/alertDefinition/AlertDefinitionPortTimeInfoPanelTpl.stache'

/**
 * @class AlertDefinitionPortTimeInfoPanel
 * Alert Definition "Port Time" Form.
 */
let AlertDefinitionPortTimeInfoPanel = AlertDefinitionInfoPanel.extend({
  id: 'alertDefinitionPortTimeInfoPanel',
  childTpl: AlertDefinitionPortTimeInfoPanelTplStache,
})
export default AlertDefinitionPortTimeInfoPanel
